// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const RecordSchema = z.object({
    name: z.string().min(1, 'Required'),
    type: z.string().min(1, 'Required'),
    status: z.string().min(1, 'Required'),
    dimensions: z.array(z.object({
        name: z.string().min(1, 'Required'),
    })).optional(),
});
